module.exports = __webpack_public_path__ + "static/img/yongsan-development.88486cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/yongsan-development.jpg
// module id = No2y
// module chunks = 0